import React from 'react';

const DropdownUserResponsive = () => {
    return (
        <div className="dropdown_user">
            <button data-href="logado" className="btn btn--icon dropdown-toggle" type="button">
                <span className="dropdown_user_img"><span className="icon icon-user"></span></span>
            </button>
        </div>
    )
}

export default DropdownUserResponsive;